<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<dash-gis-custom-chart
    [view]="[width, height]"
    [showLegend]="legend"
    [legendOptions]="legendOptions"
    [activeEntries]="activeEntries"
    [animations]="animations"
    (legendLabelActivate)="onActivate($event, true)"
    (legendLabelDeactivate)="onDeactivate($event, true)"
    (legendLabelClick)="onClick($event)">
    <svg:g [attr.transform]="translation" class="pie-chart chart">
        <svg:g dash-gis-custom-pie-series
            [colors]="colors"
            [series]="data"
            [showLabels]="labels"
            [labelFormatting]="labelFormatting"
            [trimLabels]="trimLabels"
            [maxLabelLength]="maxLabelLength"
            [activeEntries]="activeEntries"
            [innerRadius]="innerRadius"
            [outerRadius]="outerRadius"
            [explodeSlices]="explodeSlices"
            [gradient]="gradient"
            [animations]="animations"
            [tooltipDisabled]="tooltipDisabled"
            [tooltipTemplate]="tooltipTemplate"
            [tooltipText]="tooltipText"
            (dblclick)="dblclick.emit($event)"
            (select)="onClick($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)"
        ></svg:g>
    </svg:g>
</dash-gis-custom-chart>
